/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type GetAdvancedPrefilledIntakeNoteQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetAdvancedPrefilledIntakeNoteQuery = {
  __typename?: 'Query'
  prefilledIntakeNote: {
    __typename?: 'PrefilledIntakeNote'
    OBSTACLES?: string | null
    EMPLOYMENT?: { __typename?: 'IntakeNoteEmployment'; STATUS?: Types.IntakeNoteEmploymentStatus | null } | null
    HEALTH_HISTORY?: {
      __typename?: 'IntakeNoteHealthHistory'
      BIPOLAR: boolean
      DEPRESSION: boolean
      DTD: boolean
      GENERALISED_ANXIETY: boolean
      PSYCHOSIS: boolean
      PTSD: boolean
      SUBSTANCE_ABUSE: boolean
      SUICIDALITY: boolean
      THERAPY: boolean
    } | null
  }
}

export const GetAdvancedPrefilledIntakeNoteDocument = gql`
  query getAdvancedPrefilledIntakeNote($uid: ID!) {
    prefilledIntakeNote(uid: $uid) {
      EMPLOYMENT {
        STATUS
      }
      HEALTH_HISTORY {
        BIPOLAR
        DEPRESSION
        DTD
        GENERALISED_ANXIETY
        PSYCHOSIS
        PTSD
        SUBSTANCE_ABUSE
        SUICIDALITY
        THERAPY
      }
      OBSTACLES
    }
  }
`

/**
 * __useGetAdvancedPrefilledIntakeNoteQuery__
 *
 * To run a query within a React component, call `useGetAdvancedPrefilledIntakeNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedPrefilledIntakeNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedPrefilledIntakeNoteQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetAdvancedPrefilledIntakeNoteQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdvancedPrefilledIntakeNoteQuery,
    GetAdvancedPrefilledIntakeNoteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedPrefilledIntakeNoteQuery, GetAdvancedPrefilledIntakeNoteQueryVariables>(
    GetAdvancedPrefilledIntakeNoteDocument,
    options
  )
}
export function useGetAdvancedPrefilledIntakeNoteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdvancedPrefilledIntakeNoteQuery,
    GetAdvancedPrefilledIntakeNoteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedPrefilledIntakeNoteQuery, GetAdvancedPrefilledIntakeNoteQueryVariables>(
    GetAdvancedPrefilledIntakeNoteDocument,
    options
  )
}
export type GetAdvancedPrefilledIntakeNoteQueryHookResult = ReturnType<typeof useGetAdvancedPrefilledIntakeNoteQuery>
export type GetAdvancedPrefilledIntakeNoteLazyQueryHookResult = ReturnType<
  typeof useGetAdvancedPrefilledIntakeNoteLazyQuery
>
export type GetAdvancedPrefilledIntakeNoteQueryResult = Apollo.QueryResult<
  GetAdvancedPrefilledIntakeNoteQuery,
  GetAdvancedPrefilledIntakeNoteQueryVariables
>
